import request from "@/utils/request"

// 登录
export function regToken(params) {
  return request({
    url: "/oauth/regtoken",
    method: "post",
    data: params
  });
}

// 登录
export function regWoithCardID(data) {
  return request({
    url: "/oauth/regWoithCardID",
    method: "post",
    data: data
  });
}

// 刷新
export function refreshToken() {
  return request({
    url: "/oauth/refreshToken",
    method: "get"
  });
}

// 忘记密码
export function forgotPwdFirst(params) {
  return request({
    url: "/oauth/forgotPwdFirst",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/platform/auth.js